"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPaginationReadoutItem = void 0;
var _PaginationReadoutItem = require("./PaginationReadoutItem");
// TODO: in v9, move styled() from PaginationReadoutItem.jsx to here
var StyledPaginationReadoutItem = _PaginationReadoutItem.PaginationReadoutItem;
exports.StyledPaginationReadoutItem = StyledPaginationReadoutItem;